export default "__VITE_ASSET__179346c5__"